module.exports = __webpack_public_path__ + "static/media/flipCard.946f3d14.less";


//////////////////
// WEBPACK FOOTER
// ./src/Content/Less/flipCard.less
// module id = 956
// module chunks = 0